import { render, staticRenderFns } from "./EditItemWindow.vue?vue&type=template&id=6047644f&scoped=true&"
import script from "./EditItemWindow.vue?vue&type=script&lang=js&"
export * from "./EditItemWindow.vue?vue&type=script&lang=js&"
import style0 from "./EditItemWindow.vue?vue&type=style&index=0&id=6047644f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6047644f",
  null
  
)

export default component.exports